import { Button, Icon } from "@stellar/design-system";

import { DisbursementVerification } from "@/components/DisbursementVerification";

import { SummaryRow } from "./SummaryRow";

import { Disbursement, hasWallet } from "@/types";


interface StepVerificationProps {
  draftDetails?: Disbursement;
  verificationTypes: string[];
  isDraftEnabled: boolean;
  isSavePending: boolean;
  onVerificationChange: (val: string) => void;
  onNext: () => void;
  onBack: () => void;
  onSaveDraft: () => void;
}

export const StepVerification = ({
  draftDetails,
  verificationTypes,
  isDraftEnabled,
  isSavePending,
  onVerificationChange,
  onNext,
  onBack,
  onSaveDraft,
}: StepVerificationProps) => {
  const isWalletAddressType = hasWallet(draftDetails?.registrationContactType);
  const isVerificationSelected = isWalletAddressType || Boolean(draftDetails?.verificationField);

  return (
    <form
      onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onNext();
      }}
      className="DisbursementForm"
    >
      <SummaryRow
        walletName={draftDetails?.wallet?.name}
        assetCode={draftDetails?.asset?.code}
        registrationContactType={draftDetails?.registrationContactType}
      />
      <DisbursementVerification
        value={draftDetails?.verificationField ?? ""}
        options={verificationTypes}
        onChange={onVerificationChange}
      />

      <div className="DisbursementButtons">
        <Button
          variant="tertiary"
          size="md"
          icon={<Icon.ArrowLeft />}
          iconPosition="left"
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.preventDefault();
            onBack();
          }}
          disabled={isSavePending}
        >
          Back
        </Button>
        <div className="DisbursementButtons--continue">
          <Button
            variant="tertiary"
            size="md"
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              onSaveDraft();
            }}
            disabled={!isDraftEnabled || isSavePending}
            isLoading={isSavePending}
          >
            Save draft
          </Button>
          <Button
            variant="primary"
            size="md"
            icon={<Icon.ArrowRight />}
            iconPosition="right"
            type="submit"
            disabled={!isVerificationSelected || isSavePending}
          >
            Next
          </Button>
        </div>
      </div>
    </form>
  );
};
